import { createSlice } from '@reduxjs/toolkit';

import type { UserResponse } from './types';

export const slice = createSlice({
    initialState: {
        currentUser: undefined as UserResponse | undefined,
        hasCompleteProfile: false
    },

    name: 'useCurrentUser',

    reducers: {
        currentUser: (state, action) => {
            state.currentUser = action.payload;

            state.hasCompleteProfile = action.payload
                ? Boolean(
                      action.payload?.firstName && action.payload?.lastName && action.payload?.phone
                  )
                : false;
        }
    }
});

export default slice.reducer;
